// extracted by mini-css-extract-plugin
module.exports = {"AvailableMeals":"AvailableMeals_AvailableMeals__LCPYP","meals-appear":"AvailableMeals_meals-appear__1f6e1"};